var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
        _c("div", { staticClass: "card card-signin my-5" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("h5", { staticClass: "card-title text-center" }, [
              _vm._v("Register")
            ]),
            _vm._v(" "),
            _c(
              "form",
              {
                staticClass: "form-signin",
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return _vm.register.apply(null, arguments)
                  }
                }
              },
              [
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.name,
                        expression: "name"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      id: "inputName",
                      placeholder: "Name",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.name },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.name = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputName" } }, [_vm._v("Name")])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.email,
                        expression: "email"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "email",
                      id: "inputEmail",
                      placeholder: "Email address",
                      required: "",
                      autofocus: ""
                    },
                    domProps: { value: _vm.email },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.email = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputEmail" } }, [
                    _vm._v("Email address")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.password,
                        expression: "password"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      id: "inputPassword",
                      placeholder: "Password",
                      required: ""
                    },
                    domProps: { value: _vm.password },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.password = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputPassword" } }, [
                    _vm._v("Password")
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-label-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.confirmPassword,
                        expression: "confirmPassword"
                      }
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "password",
                      id: "inputConfirmPassword",
                      placeholder: "Confirm Password",
                      required: ""
                    },
                    domProps: { value: _vm.confirmPassword },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.confirmPassword = $event.target.value
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("label", { attrs: { for: "inputConfirmPassword" } }, [
                    _vm._v("Confirm Password")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass:
                      "btn btn-lg btn-primary btn-block text-uppercase",
                    attrs: { type: "submit" }
                  },
                  [_vm._v("Register")]
                )
              ]
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }